export default __webpack_public_path__ + "static/media/skypostal.2c5591b3.png";